export default __webpack_public_path__ + "static/biohazard_w.e00328761e9715b91a5d0630a6fb73ff.png";